import { useState } from 'react'

export const useLocalStorage = <T,>(
  key: string,
  initialValue: T,
  options?: {
    serialize?: (value: T) => string
    deserialize?: (value: string) => T
  }
): [T, (value: T) => void] => {
  const { serialize = JSON.stringify, deserialize = JSON.parse } = options || {}

  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key)
      return item ? deserialize(item) : initialValue
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error)
      return initialValue
    }
  })

  const setValue = (value: T) => {
    try {
      setStoredValue(value)
      window.localStorage.setItem(key, serialize(value))
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error)
    }
  }

  return [storedValue, setValue]
}

export const useStoredDate = (key: string, defaultValue: Date) => {
  return useLocalStorage<Date>(key, defaultValue, {
    serialize: (date: Date) => date.toISOString(),
    deserialize: (isoString: string) => new Date(isoString),
  })
}
